import { render, staticRenderFns } from "./ClassEntity.vue?vue&type=template&id=c3d43872"
import script from "./ClassEntity.vue?vue&type=script&lang=js"
export * from "./ClassEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3d43872')) {
      api.createRecord('c3d43872', component.options)
    } else {
      api.reload('c3d43872', component.options)
    }
    module.hot.accept("./ClassEntity.vue?vue&type=template&id=c3d43872", function () {
      api.rerender('c3d43872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/ClassEntity.vue"
export default component.exports